import translator from 'core/localization/localization';

export { translator } from './localization';

export const i18n = translator({
	Validate: {
		no: 'Validering',
	},
	'Unit Label': {
		no: 'Enhet Navn',
	},
	Formula: {
		no: 'Formel',
	},
	'Create assetgroup': {
		no: 'Opprett assetgruppe',
	},
	'Rediscover disks': {
		no: 'SÃ¸k etter disker pÃ¥ nytt',
	},
});
